<template>
<div>
    <BreadCrumb class="bread" :breads="['设备管理','理货任务']"></BreadCrumb>
    <div class="wrap">
        <div class="header">
            <span class="nameFt">理货任务</span>
        </div>
        <div class="submit-form">
            <el-form :model="search" :inline="true" size="small" label-width="80px">
                <div class="submit-form__search">
                    <el-form-item label="状态">
                        <el-select v-model="search.task_state">
                            <el-option label="待出库" value="1"></el-option>
                            <el-option label="已出库" value="2"></el-option>
                            <el-option label="已退库" value="3"></el-option>
                            <el-option label="已补货" value="4"></el-option>
                            <el-option label="已作废" value="5"></el-option>
                            <el-option label="传输失败" value="6"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="日期">
                        <el-date-picker v-model="search.task_date" value-format="yyyy-MM-dd" size="small" type="date" :picker-options="pickerOptions" placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                </div>
                <div class="submit-form__operate">
                    <el-form-item>
                        <el-button class="queryBtn" size="small" type="primary" @click="searchForm">查询</el-button>
                        <el-button class="queryBtn" size="small" @click="reset">重置</el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <div class="operate-con">
            <el-button size="small" @click="openAdd">新增</el-button>
            <el-button size="small" type="primary" @click="exportExcel">导出列表csv</el-button>
            <el-button size="small" type="primary" @click="exportExcel2">导出列表xls</el-button>
               <el-button size="small" type="success" @click="expoetmodify">导出详情csv</el-button>
                <el-button size="small" type="success" @click="expoetmodify2">导出详情xls</el-button>
        </div>

        <div class="MainTable">
            <el-table :data='tableList' stripe id="MainTables" style="width: 100%" v-loading="loading" ref="multipleTable" @selection-change="handleSelectionChange">

                <el-table-column label="序号" align="center" type="index" :index="indexMethod"></el-table-column>
                <el-table-column prop="created_by" label="创建人信息" align="center">
                </el-table-column>
                <el-table-column prop="hard_number" label="机器编号" align="center">
                </el-table-column>
                <el-table-column prop="line_name" label="线路名称" align="center">
                </el-table-column>
                <el-table-column prop="point_name" label="点位名称" align="center">
                </el-table-column>

                <el-table-column prop="restocked" label="补货信息" align="center">
                </el-table-column>
                <el-table-column prop="shipped" label="出库信息" align="center">
                </el-table-column>
                <el-table-column prop="reversed_entry" label="退库信息" align="center">
                </el-table-column>
                <el-table-column prop="obsolete" label="作废信息" align="center">
                </el-table-column>
                <el-table-column prop="total_qty" label="商品数量" align="center">
                </el-table-column>
                <el-table-column prop="under_terminal" label="归属" align="center">
                    <template slot-scope="scope">
                        <div v-if="scope.row.under_terminal==1" style="color:green">麦杰思</div>
                        <div v-if="scope.row.under_terminal==2" style="color:blue">轻购云</div>
                    </template>

                </el-table-column>
                <el-table-column prop="task_state" label="状态" align="center">
                    <template slot-scope="scope">
                        <div v-if="scope.row.task_state==1" style="color:orchid">待出库</div>
                        <div v-if="scope.row.task_state==2" style="color:green">已出库</div>
                        <div v-if="scope.row.task_state==3" style="color:brown">已退库</div>
                        <div v-if="scope.row.task_state==4" style="color:blueviolet">已补货</div>
                        <div v-if="scope.row.task_state==5" style="color:black">已作废</div>
                        <div v-if="scope.row.task_state==6" style="color:red">推送第三方错误</div>
                    </template>
                </el-table-column>
                <el-table-column prop="task_state" label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button size="small" type="text" @click="modify(scope.row.id)" :disabled="scope.row.task_state !=1">修改</el-button>
                       
                        <!-- <el-button size="small" type="text" @click="modify(scope.row.id)">修改</el-button> -->
                        <el-button size="small" type="text" @click="modifySee(scope.row.id)">详情</el-button>
                        <el-button size="small" type="text" v-if="scope.row.task_state==1" @click="pending(scope.row,2)">出库</el-button>
                        <el-button size="small" type="text" v-if="scope.row.task_state==1" @click="pending(scope.row,5)">作废</el-button>
                        <el-button size="small" type="text" v-if="scope.row.task_state==2" @click="pending(scope.row,3)">退库</el-button>
                        <el-button size="small" type="text" v-if="scope.row.task_state==3" @click="pending(scope.row,5)">作废</el-button>
                        <el-button size="small" type="text" v-if="scope.row.task_state==6 && scope.row.under_terminal == 2" @click="nextPending(scope.row)">再推送</el-button>
                    </template>
                </el-table-column>

            </el-table>
            <!-- <div style="margin-top: 20px; display: flex; justify-content: space-between; align-items: center;">
                <div>已选 {{ multipleSelection.length }} 项</div>
                <div>
                    <el-button type="primary" size="small" @click="submitSelection">加入补货单</el-button>
                    <el-button type="success" size="small" @click="submitData">查看补货单数据</el-button>
                </div>
            </div> -->

            <div class="paginationWrap">
                <el-pagination @current-change="handleCurrentChange" :page-size="10" :current-page="itemsPaging.page_index" layout="total, prev, pager, next" :total="itemsPaging.total_count">
                </el-pagination>
            </div>

        </div>

    </div>

    <SimplePrint node="MainTables" :tableList="tableList" :show="printVisible" @close="closePrint"></SimplePrint>
</div>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb";
import SimplePrint from "@/components/SimplePrint";
import apis from "@/config/apis";
import alert from "@/plugins/alert";
import {
    download
} from "@/plugins/util";
import listMixin from "@/mixins/list";
export default {
    name: "PointManagement",
    mixins: [listMixin],
    data() {
        return {
            Rem: 1,
            search: {
                page_index: 1,
                page_size: 10,
                task_state: "",
                task_date: "",
            },
            tableList: [],
            row_id: "",
            showDialog: false,
            removeData: "",

            printVisible: false,
            multipleSelection: [], // 当前页选中的项
            selectedAllList: [], // ✅ 所有页累计的选中项（补货单数据）
            itemsPaging: {},
        };
    },
    created() {
        this.search = Object.assign(this.search, this.$route.query);
        this.getData();
    },
    methods: {

        handleSelectionChange(val) {
            this.multipleSelection.forEach(item => {
                const exists = this.selectedAllList.some(sel => sel.id === item.id);
                if (!exists) this.selectedAllList.push(item);
            });
            this.multipleSelection = val
        },
        toggleAll() {
            if (this.multipleSelection.length === this.tableList.length) {
                this.$refs.multipleTable.clearSelection()
            } else {
                this.tableList.forEach(row => {
                    this.$refs.multipleTable.toggleRowSelection(row, true)
                })
            }
        },
        // ✅ 点击生成补货单按钮
        submitSelection() {
            if (!this.multipleSelection.length) {
                this.$message.warning("请先选择数据");
                return;
            }

            // 保存数据到本地存储
            const stored = JSON.parse(localStorage.getItem("replenish_list") || "[]");
            const combined = [...stored];

            this.multipleSelection.forEach(item => {
                if (!combined.some(x => x.id === item.id)) {
                    combined.push(item);
                }
            });

            localStorage.setItem("replenish_list", JSON.stringify(combined));
            this.$message.success("已加入补货单");

        },
        submitData() {
            this.$router.push({
                name: "restocked"
            })
        },
        openAdd() {
            this.$router.push({
                name: 'deviceList'
            })
        },
        modify(id) {
            this.$router.push({
                name: 'modifyRestock',
                query: {
                    id: id
                }
            })
        },

        searchForm() {
            this.search.page_index = 1;
            this.getData();
        },
        getData() {
            let params = {
                page_index: this.search.page_index,
                page_size: this.search.psge_size,
                task_state: this.search.task_state,
                task_date: this.search.task_date
            }
            this.$axios.get(apis.stock_up_task, {
                params
            }).then(res => {
                this.tableList = res.data.data;
                this.itemsPaging = res.data.pagination;
            })
            // this.getTableData(apis.terminal_exhibition, "get", this.search);
        },
        handleCurrentChange(val) {
            this.search.page_index = val;
            this.getData();
        },
        reset() {
            this.search = {};
            this.search.page_index = 1;
            this.searchForm();
        },
        removeClick(row) {
            this.row_id = row.id;
            this.showDialog = true;
        },
        modifySee(id) {
            this.$router.push({
                name: 'modifyRestock',
                query: {
                    id: id,
                    operate: "look"
                }
            })
        },
        pending(row, type) {
            alert.restockAlert().then(next => {
                this.$axios.get(apis.stock_up_task_state + row.id + "/" + type + "/").then(res => {
                    if (res.data.code == 200) {
                        this.$message({
                            message: "补货状态修改成功",
                            type: "success"
                        });
                        this.getData();
                    } else {
                        this.$message({
                            message: res.data.msg,
                            type: "error"
                        });
                    }
                });
            });
        },
        nextPending(row) {
            alert.restockAlert().then(next => {
                this.$axios.get(apis.stock_up_task_update + row.id + "/").then(res => {
                    if (res.data.code == 200) {
                        this.$message({
                            message: "补货再次推送修改成功",
                            type: "success"
                        });
                        this.getData();
                    } else {
                        this.$message({
                            message: res.data.msg,
                            type: "error"
                        });
                    }
                });
            });
        },

        exportExcel() {
            const loading = this.$loading({
                lock: true,
                text: '导出下载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'

            });
            // console.log(this.queryObj);
            let _queryObj = Object.assign(this.search, {
                details: false,
                export:true,
                export_type:'csv'
            });
            download(
                this,
                apis.stock_up_task,
                "理货任务列表.csv",
                "get",
                _queryObj
            ).then(() => {
                loading.close()
            }).catch(() => {
                loading.close()
                this.$message({
                    message: '数据过多或网速较慢,下载超时，建议重新选择下载!',
                    type: 'warning'
                })
            })
        },
         exportExcel2() {
         const loading = this.$loading({
        lock: true,
        text: '导出下载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'

      });
            let url = `${apis.stock_up_task}`;
            this.$axios
              .get(url, {
                params: Object.assign(this.search, { export: true, export_type:'xls', details: false, }),
                responseType: "arraybuffer",
              })
              .then((res) => {
                loading.close()
                let url = window.URL.createObjectURL(
                  new Blob([res.data], {
                    type: "application/vnd.ms-excel",
                  })
                );
                let link = document.createElement("a");
                link.style.display = "none";
                link.href = url;
                link.setAttribute("download", "理货任务列表" + ".xls");
                document.body.appendChild(link);
                link.click();
              });
        },
        //  exportExcel() {
        //     const loading = this.$loading({
        //         lock: true,
        //         text: '导出下载中',
        //         spinner: 'el-icon-loading',
        //         background: 'rgba(0, 0, 0, 0.7)'

        //     });
        //     // console.log(this.queryObj);
        //     let _queryObj = Object.assign(this.search, {
        //         details: false,
        //         export:true,
        //         export_type:'excel'
        //     });
        //     download(
        //         this,
        //         apis.stock_up_task,
        //         "理货任务列表.excel",
        //         "get",
        //         _queryObj
        //     ).then(() => {
        //         loading.close()
        //     }).catch(() => {
        //         loading.close()
        //         this.$message({
        //             message: '数据过多或网速较慢,下载超时，建议重新选择下载!',
        //             type: 'warning'
        //         })
        //     })
        // },
        expoetmodify(){
              const loading = this.$loading({
                lock: true,
                text: '导出下载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'

            });
            // console.log(this.queryObj);
            let _queryObj = Object.assign(this.search, {
                details: true,
                 export:true,
                export_type:'csv'
            });
            download(
                this,
                apis.stock_up_task,
                "理货任务详情.csv",
                "get",
                _queryObj
            ).then(() => {
                loading.close()
            }).catch(() => {
                loading.close()
                this.$message({
                    message: '数据过多或网速较慢,下载超时，建议重新选择下载!',
                    type: 'warning'
                })
            })
        },

          expoetmodify2() {
         const loading = this.$loading({
        lock: true,
        text: '导出下载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'

      });
            let url = `${apis.stock_up_task}`;
            this.$axios
              .get(url, {
                params: Object.assign(this.search, { export: true, export_type:'xls', details: true, }),
                responseType: "arraybuffer",
              })
              .then((res) => {
                loading.close()
                let url = window.URL.createObjectURL(
                  new Blob([res.data], {
                    type: "application/vnd.ms-excel",
                  })
                );
                let link = document.createElement("a");
                link.style.display = "none";
                link.href = url;
                link.setAttribute("download", "理货任务详情" + ".xls");
                document.body.appendChild(link);
                link.click();
              });
        },
   
    },

    components: {
        BreadCrumb,
        SimplePrint
    }
};
</script>

<style lang="scss" scoped>
/*弹窗*/
.el-icon-warning {
    color: #e6a23c;
    font-size: 60px;
}

.Main {
    text-align: center;

    .infoOne {
        font-size: 28px;
        line-height: normal;
    }

    .infoTwo {
        padding-top: 10px;
        font-size: 14px;
    }
}
</style>
